import {
    Button,
    Container,
    Paper,
    Dialog,
    Stack,
    Typography,
    TextField as MuiTextField,
    IconButton,
    Box
  } from '@mui/material';
  import { Checkbox, FormProvider, SelectTag, Table, TextField } from '../../../../../components';
  import { useForm } from 'react-hook-form';
  import SearchIcon from '@mui/icons-material/Search';
  import { yupResolver } from '@hookform/resolvers/yup';
    import CloseIcon from '@mui/icons-material/Close';
  import * as Yup from 'yup';

  import {
    getCurrentDateTime,
    getKeyPathValue,
    getISTDate,
    request,
    toast,
    formatDate,
    calculateAge
  } from '../../../../../utils';
  import { useCallback, useEffect, useState } from 'react';
  import { useLocation } from 'react-router-dom';
  import { CustomButtonn } from '../../../../../components';
import { IPDSearchHandlerAllBillManagement } from '../../HMS/transactions/utils/IPDSearchHandlerAllBillManagement';
  
  const initialTpaClaimAmountDataObj = {
    data: [],
    loading: false
  };
  

    const TABLE_COLUMNS = [
    { header: 'Date', accessor: (row) => `${formatDate(row?.date)}` },
    { header: 'UHID No.', accessor: 'uhid' },
    { header: 'IPD No.', accessor: 'ipd_no' },
    { header: 'Patient Name', accessor: (row)=> row?.patient?.name},
     { header: 'Sponsor', accessor: (row)=> row?.patient?.sponsor?.name },
 
  ];


  export const TpaClaimAmount = () => {
    const { pathname } = useLocation();
    const lastPathSegment = pathname.split('/').pop();
    const pathParts = pathname.split('/');
    const organisation = pathParts[1];
    const [loading, setLoading] = useState(false);
    const [tpaClaimAmountDataObj, setTpaClaimAmountDataObj] = useState(initialTpaClaimAmountDataObj);
    const [openQueryDialog, setOpenQueryDialog] = useState(false);
    const [currentAction, setCurrentAction] = useState();
    const [selectedRecord, setSelectedRecord] = useState();
    const [ipdAllDetailListDialogue,setIpdAllDetailListDialogue] = useState(false)
    const [input, setInput] = useState('');
    const [selectedRow,setSelectedRow]= useState(false)
    const user = JSON.parse(localStorage.getItem('user'));
  
  
    const isEnabledDate =
      user && user.permissions ? user.permissions.some((permission) => permission.includes('DatePermission')) : false;
  
    const methods = useForm({
      resolver: yupResolver(
        Yup.object().shape({ })
      ),
      defaultValues: {
       date: getISTDate(),
        time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),
      },
      mode: 'all'
    });
    const { handleSubmit, watch, setValue, reset } = methods;

  useEffect(() => {
    if (selectedRecord) {
      const keyValuePair = getKeyPathValue(selectedRecord, '', ['_id', 'status', '__v']);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      const formattedDate = selectedRecord?.date ? new Date(selectedRecord.date).toISOString().split('T')[0] : '';
      const initialDate = selectedRecord?.initial_date ? new Date(selectedRecord.initial_date).toISOString().split('T')[0] : '';
      const formatClaimDate = selectedRecord?.claim_date ? new Date(selectedRecord.claim_date).toISOString().split('T')[0] : '';
      const formatApprovedDate = selectedRecord?.approved_date ? new Date(selectedRecord.approved_date).toISOString().split('T')[0] : '';
      const formatReceivedDate =  selectedRecord?.received_date ? new Date(selectedRecord.received_date).toISOString().split('T')[0] : '';
      setValue('date', formattedDate);
      setValue('initial_date',initialDate)
      setValue('claim_date',formatClaimDate)
      setValue('approved_date',formatApprovedDate)
      setValue('received_date',formatReceivedDate)
      setValue('patient_name',selectedRecord?.patient?.name)
      setValue('age', calculateAge(selectedRecord?.patient?.dob))
      setValue('gender',selectedRecord?.patient?.gender)
      setValue('mobile',selectedRecord.patient?.mobile)
      setValue('address',selectedRecord.patient?.address)
      setValue('doctor',selectedRecord?.indoorPatient?.consultant_detail?.doctor?.name)
      setValue('sponsor',selectedRecord?.patient?.sponsor?.name)
    } else {
      reset();
    }
  }, [setValue, reset, selectedRecord]);
  
    const formSubmit = async (formValue) => {
      setLoading(true);
      let editFlag = false;
      if (selectedRecord && currentAction === 'edit') {
        editFlag = true;
      }
      const response = await request(editFlag ? '/tpa-claim-amount-update' : '/tpa-claim-amount-create', {
        method: editFlag ? 'PUT' : 'POST',
        params: editFlag ? selectedRecord._id : null,
        body: {
          ...formValue,
          createdBy: user.name,
          updatedBy: editFlag ? user.name : '',
          organisation,
        }
      });
      if (response?.success) {
        toast(`Successfully ${editFlag ? 'updated' : 'created'} TPA Claim Amount `, { variant: 'success' });
        setSelectedRecord(response?.data);
        setCurrentAction('');
      } else {
        toast(`Failed to ${editFlag ? 'update' : 'create'} TPA Claim Amount `, {
          variant: 'error'
        });
      }
      setLoading(false);
    };
  

    const handleCancelRecord = async () => {
      setLoading(true);
      const response = await request('/tpa-claim-amount-cancel', {
        method: 'DELETE',
        params: selectedRecord._id
      });
      if (response?.success) {
        toast('Successfully TPA Claim Amount', { variant: 'success' });
        setSelectedRecord();
      } else {
        toast('Failed to TPA Claim Amount', { variant: 'error' });
      }
      setLoading(false);
    };
  
    const handleDeleteRecord = async () => {
      setLoading(true);
      const response = await request('/tpa-bill-amount-delete', {
        method: 'DELETE',
        params: selectedRecord._id
      });
      if (response?.success) {
        toast('Successfully deleted Tpa Bill Amount' ,{variant:"success"});
        setSelectedRecord();
      } else {
        toast('Failed to delete Tpa Bill Amount', { variant: 'error' });
      }
      setLoading(false);
    };
  
    const handleQueryWindow = async () => {
      setOpenQueryDialog(true);
      setTpaClaimAmountDataObj({ loading: true });
      try {
        const response = await request('/tpa-claim-amount-list', { method: 'GET' });
        if (response.success) {
          const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
          const filteredData = sortedData.filter(
            (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
          );
          setTpaClaimAmountDataObj({ loading: false, data: filteredData });
        } else {
          toast('Error in fetching data', { variant: 'error' });
          setTpaClaimAmountDataObj({ loading: false });
        }
      } catch (error) {
        console.error('Error fetching patient data:', error);
        toast('Error in fetching data', { variant: 'error' });
        setTpaClaimAmountDataObj({ loading: false });
      }
    };


    const handleSearch = async () => {
      const lowercasedInput = input.toLowerCase().trim();
      try {
        const query = {};
        if (lowercasedInput) {
          query.name = lowercasedInput;
        }
        const response = await request('/tpa-claim-amount-list', {
          method: 'GET',
          query: query
        });
        if (response.success) {
          const filteredData = response.data.filter(
            (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
          );
          setTpaClaimAmountDataObj({ loading: false, data: filteredData });
        } else {
          toast('Error in fetching dataaaaa', { variant: 'error' });
        }
      } catch (error) {
        console.error('Error during search:', error);
        toast('Error during search', { variant: 'error' });
      }
    };
  
    useEffect(() => {
      handleSearch(input);
    }, [input]);

    const handleChange =(e)=>{
     setInput(e.target.value)
    }
   

    const handleBillAmount = async(ipdNo)=>{
      const response = await request('/indoor-registeration-detail', {
      method: 'GET',
      params: ipdNo
    });
      if(response.success){
         const { data } = response;
         setValue('uhid',data.uhid);
         setValue('ipd_no',data.ipd_no)
         setValue('patient_name',`${data.patient.first_name}${data.patient.last_name}`)
         setValue('mobile',data.patient.address.mobile)
         setValue('address',data.patient.address.address)
         setValue('bill_amt',data.finalbill.net_amt)
         setValue('doctor',data.consultant_detail?.doctor?.name)
         setValue('sponsor',data.patient.sponsor.name)
         setValue('age',calculateAge(data.patient.dob))
         setValue('gender',data.patient.gender)
      }
    }



    return (
      <>
        <Paper
          sx={{
            p: 0,
            flex: 1,
            borderRadius: 0,
            boxShadow: 'none',
            width: '100%',
            height: 'auto'
          }}
        >
          <Container
            sx={{
              mt: 1,
              border: '0px solid',
              borderColor: 'grey.300',
              borderRadius: 1,
              width: '100%',
              boxSizing: 'border-box',
              minWidth: '100%'
            }}
          >
            <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
              <Stack
                direction="row"
                spacing={2}
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  mb: 1,
                  borderBottom: '0px solid',
                  borderColor: 'grey.300'
                }}
              >
                <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                  TPA Claim Amount
                </Typography>
                <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                  <CustomButtonn
                    id={`${lastPathSegment}Write`}
                    variant="contained"
                    disabled={['edit', 'new'].includes(currentAction)}
                    onClick={() => {
                      setSelectedRecord();
                      setCurrentAction('new');
                    }}
                  >
                    New
                  </CustomButtonn>
                  <CustomButtonn
                    id={`${lastPathSegment}Update`}
                    variant="contained"
                    disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                    onClick={() => setCurrentAction('edit')}
                  >
                    Edit
                  </CustomButtonn>
                  <CustomButtonn
                    id={'Submit'}
                    type="submit"
                    variant="contained"
                    disabled={!['edit', 'new'].includes(currentAction) || loading}
                  >
                    Save
                  </CustomButtonn>
                  <CustomButtonn
                    id={'Cancel'}
                    variant="contained"
                    disabled={!selectedRecord || currentAction}
                    onClick={() => {
                      setCurrentAction();
                      handleCancelRecord();
                    }}
                  >
                    Cancel
                  </CustomButtonn>
                  <CustomButtonn
                    id={`isSuperAdmin`}
                    variant="contained"
                    disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                    onClick={handleDeleteRecord}
                  >
                    Delete
                  </CustomButtonn>
                  <CustomButtonn
                    id={`${lastPathSegment}Read`}
                    variant="contained"
                    onClick={handleQueryWindow}
                    disabled={['new', 'edit'].includes(currentAction)}
                  >
                    Query
                  </CustomButtonn>
                  <CustomButtonn
                    id={`${lastPathSegment}Print`}
                    variant="contained"
                    onClick={() => {
                      window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank');
                    }}
                    disabled={!selectedRecord || currentAction}
                  >
                    Print
                  </CustomButtonn>
                  <CustomButtonn
                    id={`${lastPathSegment}Print`}
                    variant="contained"
                    onClick={() => {
                      window.open(`/print${pathname}/invoice-print?refId=${selectedRecord._id}`, '_blank');
                    }}
                    disabled={!selectedRecord || currentAction}
                  >
                    invoice Print
                  </CustomButtonn>
                  <CustomButtonn
                    id={'Exit'}
                    variant="contained"
                    onClick={() => {
                      setCurrentAction('');
                      setSelectedRecord(null);
                      window.location.reload();
                    }}
                  >
                    Exit
                  </CustomButtonn>
                </Stack>
              </Stack>
              <Box
                sx={{
                  border: '0px solid gray',
                  padding: 2,
                  borderRadius: '8px',
                  width: '100%',
                  boxShadow: '0px 2px 10px #0099ff'
                }}
              >
                <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                  <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Type</Typography>
                    <TextField
                      sx={{ flex: 0.8 }}
                      name="type"
                      disabled={!isEnabledDate || !['new', 'edit'].includes(currentAction)}
                    />
                  </Stack>
                  <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>UHID</Typography>
                    <TextField disabled sx={{ flex: 0.35 }} name="uhid" placeholder="UHID" />
                    <TextField disabled sx={{ flex: 0.35 }} name="ipd_no" placeholder="IPD No" />
                    <Button
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{
                        flex: 0.1,
                        minWidth: 0,
                        p: 0.25,
                        height: '100%',
                        position: 'relative'
                      }}
                      variant="contained"
                      onClick={() => setIpdAllDetailListDialogue(true)}
                    >
                      <SearchIcon />
                    </Button>
                  </Stack>
                  <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Patient Name</Typography>
                    <TextField
                      sx={{ flex: 0.8 }}
                      name="patient_name"
                      placeholder="Patient Name"
                      disabled

                    />
                  </Stack>
                </Stack>
                <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                  <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Date</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="date"
                      type="date"
                    />
                  </Stack>
                  <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Age/Gender</Typography>
                    <TextField
                      disabled
                      sx={{
                        flex: 0.4
                      }}
                      name="age"
                      placeholder="Age"
                    />
                    <TextField
                      disabled
                      sx={{
                        flex: 0.4
                      }}
                      name="gender"
                      placeholder="Gender"
                    />
                  </Stack>
                  <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Mobile No.</Typography>
                    <TextField
                      disabled
                      sx={{ flex: 0.8 }}
                      name="mobile"
                      placeholder="Mobile No"

                    />
                  </Stack>
                </Stack>
                <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                  <Stack sx={{ flex: 1 / 3 }} spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Doctor Name</Typography>
                    <TextField
                      disabled
                      sx={{ flex: 0.8 }}
                      name="doctor"
                      placeholder="Doctor name"
                    />
                  </Stack>
                  <Stack sx={{ flex: 1 / 1.5 }} spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.19, fontWeight: 700, fontSize: '1.4rem' }}>Address</Typography>
                    <TextField
                      disabled
                      sx={{
                        flex: 1
                      }}
                      name="address"
                      placeholder="Address"
                    />
                  </Stack>
                </Stack>
                <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                  <Stack sx={{ flex: 1 / 3 }} direction="row" alignItems="center" spacing={0.5}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Sponsor Name</Typography>
                    <TextField
                      disabled
                      sx={{ flex: 0.8, fontWeight: 700, fontSize: '1.4rem' }}
                      name="sponsor"
                    />
                  </Stack>
                  <Stack sx={{ flex: 1 / 3 }} direction="row" alignItems="center" spacing={0.5}>
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Bill Amount</Typography>
                    <TextField type="number" disabled sx={{ flex: 0.8 }} name="bill_amt" />
                  </Stack>
                  <Stack sx={{ flex: 1 / 3 }} alignItems="center" direction="row" spacing={0.5}>
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Claim Id</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="claim_id"
                      placeholder="Claim ID"
                    />
                  </Stack>
                </Stack>
                <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                  <Stack spacing={0.4} sx={{ flex: 1 / 3 }} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Initial Amt.</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction) || selectedRecord?.initial_amt > 0 }
                      sx={{ flex: 0.8 }}
                      name="initial_amt"
                      type="number"
                      placeholder="Initial Amount"
                    />
                  </Stack>
                  <Stack spacing={0.4} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Initial Date </Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{
                        flex: 0.8
                      }}
                      name="initial_date"
                      type="date"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Initial Remarks</Typography>
                    <TextField disabled={!['new', 'edit'].includes(currentAction)} sx={{ flex: 0.8 }} name="initial_remarks" placeholder="Initial Remarks" />
                  </Stack>
                </Stack>
                <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                  <Stack spacing={0.4} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Claim Amt.</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction) || selectedRecord?.claim_amt > 0 }
                      sx={{ flex: 0.8 }}
                      name="claim_amt"
                      placeholder="Claim Amount"
                      type="number"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Claim Date</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="claim_date"
                      type="date"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Claim Remarks</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="claim_remarks"
                      placeholder="Claim Remarks"
                    />
                  </Stack>
                </Stack>

                <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                  <Stack spacing={0.4} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Approved Amount</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction) || selectedRecord?.approved_amt > 0 }
                      sx={{ flex: 0.8 }}
                      name="approved_amt"
                      placeholder="Approved Amount"
                      type="number"
                    />
                  </Stack>
                  <Stack spacing={0.4} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.41, fontWeight: 700, fontSize: '1.4rem' }}>Approved Date</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="approved_date"
                      type="date"
                    />
                  </Stack>
                  <Stack spacing={0.4} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.41, fontWeight: 700, fontSize: '1.4rem' }}>Approved Remarks</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="approved_remarks"
                      placeholder="Approved Remarks"
                    />
                  </Stack>
                </Stack>

                <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                  <Stack spacing={0.4} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Received Amount</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction) || selectedRecord?.received_amt > 0 }
                      sx={{ flex: 0.8 }}
                      name="received_amt"
                      placeholder="Received Amount"
                      type="number"
                    />
                  </Stack>
                  <Stack spacing={0.4} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.41, fontWeight: 700, fontSize: '1.4rem' }}>Received Date</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="received_date"
                      type="date"
                    />
                  </Stack>
                  <Stack spacing={0.4} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.41, fontWeight: 700, fontSize: '1.4rem' }}>Received Remarks</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      name="received_remarks"
                      placeholder="Received Remarks"
                    />
                  </Stack>
                </Stack>

                <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                  <Stack spacing={0.4} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>TDS Amount</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction) || selectedRecord?.tds_amt > 0 }
                      sx={{ flex: 0.8 }}
                      name="tds_amt"
                      placeholder="TDS Amount"
                      type="number"
                    />
                  </Stack>
                  <Stack spacing={0.4} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.41, fontWeight: 700, fontSize: '1.4rem' }}>Hospital Discount</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction) || selectedRecord?.hospital_disc > 0 }
                      sx={{ flex: 0.8 }}
                      name="hospital_disc"
                      type="number"
                    />
                  </Stack>
                  <Stack spacing={0.4} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.41, fontWeight: 700, fontSize: '1.4rem' }}>Co Payment</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction) || selectedRecord?.co_payment > 0 }
                      sx={{ flex: 0.8 }}
                      name="co_payment"
                      placeholder="Co Payment"
                      type="number"
                    />
                  </Stack>
                </Stack>

                <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                  <Stack spacing={0.4} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                    <Typography sx={{ flex: 0.27, fontWeight: 700, fontSize: '1.4rem' }}>Other Charges</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction) || selectedRecord?.other_charges > 0 }
                      sx={{ flex: 0.7 }}
                      name="other_charges"
                      placeholder="Other Charges"
                      type="number"
                    />
                  </Stack>
                </Stack>
              </Box>
              {/* </Grid> */}
            </FormProvider>
          </Container>
        </Paper>

        <Dialog
          open={openQueryDialog}
          onClose={() => {
            setOpenQueryDialog(false);
          }}
          PaperProps={{ sx: { width: '80%', p: 2 } }}
          maxWidth="xl"
          scroll="body"
        >
          <Stack
            padding={0}
            direction="row"
            spacing={2}
            alignItems="center"
            justifyContent="space-between"
            borderBottom="1px solid"
            borderColor="grey.300"
          >
            <Typography variant="h4" fontWeight="bold">
              Tpa Claim Amount Query Window
            </Typography>
            <IconButton
              onClick={() => {
                setOpenQueryDialog(false);
              }}
            >
              <CloseIcon color="error" fontSize="large" />
            </IconButton>
          </Stack>
          <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
            <MuiTextField
              sx={{
                width: '100%',
                '& .MuiOutlinedInput-root': {
                  padding: '0',
                  fontSize: '14px'
                },
                '& .MuiOutlinedInput-input': {
                  padding: '8px 10px'
                },
                '& .MuiInputLabel-root': {
                  fontSize: '1.2rem'
                }
              }}
              label="Search Patient"
              placeholder="Search Patient"
              variant="outlined"
              value={input}
              onChange={handleChange}
            />
          </Stack>
          <Table
            sx={{ mt: 0.5 }}
            columns={TABLE_COLUMNS}
            data={tpaClaimAmountDataObj.data || []}
            loading={tpaClaimAmountDataObj.loading}
            onRowClick={(row) => {
              setSelectedRecord(row)
              setOpenQueryDialog(false)
            }}
          />
        </Dialog>

        <Dialog
          PaperProps={{ sx: { p: 2 } }}
          open={ipdAllDetailListDialogue}
          onClose={() => setIpdAllDetailListDialogue(false)}
          scroll="body"
          maxWidth="xl"
        >
          <IPDSearchHandlerAllBillManagement
            onClose={() => setIpdAllDetailListDialogue(false)}
            onAdd={handleBillAmount}
            setSelectedRow={setSelectedRow}

          />
        </Dialog>
      </>
    );
  };
  